// extracted by mini-css-extract-plugin
export default {"background":"style_background__kcag+","main":"style_main__Ihaiw","close":"style_close__r5CiI","img":"style_img__pjey-","title":"style_title__dXqYG","btn":"style_btn__EQ1F+"};